module.exports = __webpack_public_path__ + "static/media/Bennet.240e72a9.png";